<template>
  <nav class="nav-container flex justify-between items-center p-2 shadow-md sticky top-0 z-50 font-serif">
       <div class="flex items-center">
     <img src="/image/im8.png" alt="Logo HotelBook" class="h-16 w-16 text-green-600 mr-2">
     <h1 class="text-1xl font-bold text-white">University | StudentGate</h1>
   </div>
   <ul class="flex gap-8 text-white">
    <ul class="flex space-x-6 items-center">
      <router-link to="/dashboard" class="hover:text-blue-400 text-1xl transition duration-300 ">Accueil  </router-link>
     <router-link to="/cours" class="hover:text-blue-400 text-1xl transition duration-300">Cours  </router-link>
     <router-link to="/calendar" class="hover:text-blue-400 text-1xl transition duration-300">Calendrier  </router-link>
     <router-link to="/eval" class="hover:text-blue-400 text-1xl transition duration-300">Evaluation  </router-link>
     
  </ul>
  
   <li class="relative" ref="menuRef">
        <div class="flex items-center cursor-pointer" @click="toggleDropdown">
          <div class="rounded-full overflow-hidden w-14 h-14 border-2 border-white">
            <img v-if="user" :src="getPhotoUrl(user.image)" alt="User Image" class="w-full h-full object-cover" />
          </div>
        </div>

        <div
          v-if="dropdownVisible && user"
          class="absolute top-full mt-2 right-0 w-64 bg-white border border-gray-300 rounded-lg shadow-lg p-4 z-50"
        >
          <p class="text-blue-900 text-center">Bienvenue</p>
          <div class="flex items-center mb-3">
            <img src="/image/im18.png" alt="Icon" class="h-8 w-8 mr-2">
            <p class="text-gray-800 font-semibold">{{ user.surname }} {{ user.name }}</p>
          </div>
          <button
            @click="logout"
            class="w-full px-4 py-2 text-blue-900 bg-gray-100 rounded hover:bg-blue-900 hover:text-white transition duration-300"
          >
            Se déconnecter
          </button>
        </div>
      </li>
 
   </ul>
  </nav>

   <!-- Bandeau -->
   <section class="nav-container py-10 text-center shadow-md font-serif">
 <p class="text-gray-200">Explorez vos cours, trouvez des ressources et avancez vers la réussite !</p>

 <input
   type="text"
   v-model="search"
   placeholder="🔍 Rechercher un cours..."
   class="rounded-full p-2 text-gray-700 w-full md:w-2/6 font-serif border-2 border-white mt-6"
 />
</section>


   <!-- Filtres -->
   <div class="bg-white flex justify-end px-4 md:px-16 pt-4 pb-8">
       <select
         v-model="selectedSemester"
         @change="fetchCoursesBySemester"
         class="nav-container rounded p-2 text-white w-full md:w-1/6 border-2 border-white font-serif"
       >
         <option value="">Tous les semestres</option>
         <option v-for="n in 6" :key="n" :value="n">Semestre {{ n }}</option>
       </select>

   </div>


   <!-- Grille de cours -->
<!-- Grille de cours avec largeur maximale contrôlée -->
<div class="bg-white w-[1700%] max-w-screen-xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10 px-4 md:px-16 pb-16 items-stretch font-serif">
  <div
   v-for="cours in paginatedCourses"
   :key="cours.id"
   class="bg-white rounded-2xl shadow-lg overflow-hidden text-black h-full"
 >

 <div class="relative hover:scale-[1.03] transform transition-all duration-300">
     <img
       :src="getImageUrl(cours.image)"
       alt="Illustration du cours"
       class="h-40 w-full object-cover"
     />
     <div class="absolute left-1/2 transform -translate-x-1/2 -bottom-7 z-10 bg-white rounded p-1 shadow-md h-14 w-28 flex items-center justify-center ">
       <img src="/image/log.png" class="h-10 w-10 object-contain" alt="logo école" />
     </div>
   </div>

   <div class="p-10 hover:scale-[1.03] transform transition-all duration-300">
     <div class="flex items-center mb-2 hover:scale-[1.03] transform transition-all duration-300">
       <img src="/image/cour.png" alt="cours" class="h-5 w-5 mr-2" />
       <h3 class="text-1xl font-bold text-blue-900">{{ cours.title }}</h3>
     </div>

     <div class="flex items-center mb-2">
       <img src="/image/prof.png" alt="professeur" class="h-4 w-4 mr-2" />
       <p class="text-sm text-gray-800">Par : {{ cours.prof }}</p>
     </div>

    <div class="flex items-start mb-2">
       <img src="/image/des.png" alt="description" class="h-4 w-4 mr-2 mt-1" />
       <p class="text-sm text-gray-800">{{ cours.description }}</p>
     </div>

     

       <div class="flex flex-col items-center mb-1">
         <a
           v-if="cours.file_path"
           :href="getFileUrl(cours.file_path)"
           target="_blank"
           class="text-sm text-white bg-blue-900 px-3 py-1 rounded hover:bg-blue-700 mb-2"
         >
           📄 Accéder au cours
         </a>

         <div v-if="cours.video_url" class="flex justify-end">
           <img src="/image/vid.png" alt="vidéo" class="h-4 w-4 mr-1" />
           <a
             :href="cours.video_url"
             target="_blank"
             class="text-sm text-blue-900 underline hover:text-blue-700"
           >
             Tutoriel disponible
           </a>
         </div>
       </div>

       <div class="flex justify-end">
         <p class="text-xs text-gray-500">Semestre : {{ cours.semester }}</p>
       </div>

         </div>
       </div>
     </div>





     <div class="flex justify-center space-x-2 mt-1 mb-6 font-serif">
  <button
    @click="currentPage--"
    :disabled="currentPage === 1"
    class="px-3 py-1 bg-white text-blue-900 rounded disabled:opacity-50"
  >
       -
  </button>

  <button
    v-for="page in totalPages"
    :key="page"
    @click="currentPage = page"
    :class="['px-3 py-1 rounded', currentPage === page ? 'bg-white text-blue-900' : 'bg-white text-gray-500']"
  >
    {{ page }}
  </button>

  <button
    @click="currentPage++"
    :disabled="currentPage === totalPages"
    class="px-3 py-1 bg-white text-blue-900 rounded disabled:opacity-50 font-serif"
  >
       +
  </button>
</div>

   <!-- Mini Footer -->
   <footer class="nav-container py-4 text-center text-sm text-gray-300 font-serif">
     &copy; 2025 University StudentGate — Tous droits réservés.
   </footer>
</template>

<script>
import axios from 'axios';

export default {
 name: 'CoursView',
 data() {
   return {
     user: null,
    dropdownVisible: false,
     cours: [],
     search: '',
     selectedSemester: '',
     currentPage: 1,
itemsPerPage: 3,


   };
 },


 mounted() {

  this.fetchCourses();


    this.fetchUser();
    document.addEventListener('click', this.closeDropdownOnClickOutside);
},

beforeUnmount() {
  document.removeEventListener('click', this.closeDropdownOnClickOutside);
  },




 computed: {
   filteredCourses() {
     return this.cours.filter((c) =>
       c.title.toLowerCase().includes(this.search.toLowerCase())
     );
   },

   paginatedCourses() {
  const start = (this.currentPage - 1) * this.itemsPerPage;
  const end = start + this.itemsPerPage;
  return this.filteredCourses.slice(start, end);
},
totalPages() {
  return Math.ceil(this.filteredCourses.length / this.itemsPerPage);
},

 },




 methods: {
   fetchCourses() {
     axios.get('https://mida-back.onrender.com/api/courses')
       .then((res) => {
         this.cours = res.data;
       });
   },

   
   fetchCoursesBySemester() {
     if (this.selectedSemester === '') {
       this.fetchCourses();
     } else {
       axios.get(`https://mida-back.onrender.com/api/courses/semester/${this.selectedSemester}`)
         .then((res) => {
           this.cours = res.data;
         });
     }
   },
   getImageUrl(path) {
     return path ? `https://mida-back.onrender.com/${path}` : '/image/default-course.jpg';
   },
   getFileUrl(path) {
     return `https://mida-back.onrender.com/${path}`;
   },

    fetchUser() {
      axios.get('https://mida-back.onrender.com/api/user', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        }
      })
      .then((res) => {
        this.user = res.data;
      })
      .catch((error) => {
        console.error('Erreur lors du fetch de l’utilisateur connecté :', error);
      });
    },

    toggleDropdown() {
    this.dropdownVisible = !this.dropdownVisible;
  },
  closeDropdownOnClickOutside(event) {
    const menu = this.$refs.menuRef;
    if (menu && !menu.contains(event.target)) {
      this.dropdownVisible = false;
    }
  },

    logout() {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      this.$router.push('/');
    },

    getPhotoUrl(path) {
      return path ? `https://mida-back.onrender.com/${path}` : '/image/default-users.jpg';
    }
  
   
 },


};
</script>

<style scoped>
.nav-container {
 background-color: #163767;
}


/* Ajoute ton style ici si tu veux encore améliorer */
</style>
